<template>
  <div class="rmr-page-shell nrd-db-page">
    <rmr-page-hero
      title="Veille"
      title-accent="globale"
      subtitle="Recherchez dans les données collectées par les sources suivies."
      :icon="icons.mdiMagnify"
    >
      <template #actions>
        <!-- L'affichage n'est pas un filtre : il ne change pas ce qu'on
             cherche, seulement la façon de le lire. Il vit donc dans l'en-tête
             de page et non dans la grille de filtres. -->
        <display-filter variant="on-dark" />
      </template>
    </rmr-page-hero>

    <section class="rmr-page-shell__content nrd-db-page__content">
      <v-card flat class="rmr-table-shell">
        <div class="rmr-table-shell__header">
          <div class="rmr-table-shell__topline">
            <div class="rmr-table-shell__heading">
              <div class="rmr-table-shell__eyebrow">News Radar</div>
              <div class="rmr-table-shell__title">Données collectées</div>
            </div>

            <!-- À droite du titre, et non dans la grille de filtres : le
                 support n'est pas un critère de plus, c'est le MODE de la
                 liste.

                 Grisé sans site, comme le bouton « Appliquer » : le support
                 vit sur la config, donc sans site l'API ne sait pas laquelle
                 consulter et rend les deux supports mélangés — c'est alors le
                 tag de chaque ligne qui dit ce qu'on regarde.

                 Pas de garde superadmin ici, contrairement à « Créer post par
                 sources » : cette page ne fait qu'afficher, elle n'appelle ni
                 /source-preview ni /video-angles. -->
            <div class="rmr-table-shell__controls">
              <media-type-segmented :disabled="!hasSite" />
            </div>
          </div>

          <div class="nrd-db-page__filters">
            <filters />
          </div>
        </div>

        <v-card-text class="rmr-table-shell__body">
          <table-results v-if="displayMode === 'dataTable'" />
          <feed-results v-else />
        </v-card-text>
      </v-card>
    </section>
  </div>
</template>

<script>
import { computed, onMounted } from "@vue/composition-api";
import { mdiMagnify } from "@mdi/js";
import isArray from "lodash/isArray";

import Filters from "@/components/news-radar/db/filters/Filters";
import TableResults from "@/components/news-radar/db/tables/Results";
import FeedResults from "@/components/news-radar/db/FeedResults.vue";
import DisplayFilter from "@/components/news-radar/db/filters/DisplayFilter.vue";
import RmrPageHero from "@/components/ui/layout/RmrPageHero.vue";
import MediaTypeSegmented from "@/components/ai-factory/post-by-sources/global-watch/parts/MediaTypeSegmented.vue";

import useProxy from "@/hooks/useProxy";
import { saveRmraView } from "@/utils/rmr-analytics";

export default {
  name: "DbOverview",
  components: {
    DisplayFilter,
    Filters,
    FeedResults,
    MediaTypeSegmented,
    RmrPageHero,
    TableResults,
  },
  setup(props, { emit }) {
    const { route, store } = useProxy();

    // =>  COMPUTED
    const displayMode = computed(
      () => store.getters["newsRadar/getDisplayMode"]
    );

    // Même normalisation que `Filters.vue` : le getter rend `[]` tant qu'aucun
    // site n'est choisi, et `![]` vaut `false` en JS.
    const hasSite = computed(() => {
      const value = store.getters["newsRadar/getSites"];
      return isArray(value) ? value.length > 0 : Boolean(value);
    });

    // =>  HOOKS
    onMounted(async () => {
      saveRmraView(route);
    });

    // =>  DATA
    return {
      displayMode,
      hasSite,
      icons: { mdiMagnify },
    };
  },
};
</script>

<style lang="scss" scoped>
.nrd-db-page__content {
  // Le fil d'actualité et le mur de briques posent leur propre mise en page :
  // la coque ne leur impose qu'une gouttière.
  padding-top: 0;
}

.nrd-db-page__filters {
  // `rmr-table-shell__header` est en `display: block` : ses enfants n'ont
  // aucune gouttière entre eux, et les `v-row` des filtres remontent encore de
  // 12px avec la marge négative de Vuetify. Sans cette marge, la première
  // ligne de filtres chevauche le titre.
  margin-top: 28px;
}
</style>
